"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TogglerIcon = exports.ContextMenuList = exports.ContextMenuItemCaption = exports.ContextMenuItem = exports.ContextMenu = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Overflow = _interopRequireDefault(require("../../Icons/Overflow"));
const TogglerIcon = exports.TogglerIcon = (0, _styledComponents.default)(_Overflow.default).withConfig({
  displayName: "contextMenu__TogglerIcon",
  componentId: "sc-5y83bd-0"
})(["fill:", ";cursor:pointer;vertical-align:middle;"], props => props.theme.colors.buttonGroup.contextMenu.trigger.icon);
const ContextMenuItem = exports.ContextMenuItem = _styledComponents.default.div.withConfig({
  displayName: "contextMenu__ContextMenuItem",
  componentId: "sc-5y83bd-1"
})(["background-color:", ";border-width:", ";border-style:", ";border-color:", ";padding:0 20px;min-width:230px;height:", ";display:flex;flex-direction:row;align-items:center;cursor:", ";", ""], ({
  theme
}) => theme.colors.buttonGroup.contextMenu.item.bg, ({
  theme
}) => theme.buttonGroup.contextMenu.item.borderWidth, ({
  theme
}) => theme.buttonGroup.contextMenu.item.borderStyle, ({
  theme
}) => theme.colors.buttonGroup.contextMenu.item.border, ({
  theme
}) => theme.buttonGroup.contextMenu.item.height, props => props.isDisabled ? 'default' : 'pointer', props => !props.isDisabled && `
    &:hover {
      background-color: ${props.theme.colors.buttonGroup.contextMenu.item.hoverBg};
    }
  `);
const ContextMenuItemCaption = exports.ContextMenuItemCaption = _styledComponents.default.span.withConfig({
  displayName: "contextMenu__ContextMenuItemCaption",
  componentId: "sc-5y83bd-2"
})(["font-family:", ";font-size:", ";font-weight:", ";line-height:", ";letter-spacing:", ";color:", ";text-transform:", ";opacity:", ";"], ({
  theme
}) => theme.buttonGroup.contextMenu.item.fontFamily, ({
  theme
}) => theme.buttonGroup.contextMenu.item.fontSize, ({
  theme
}) => theme.buttonGroup.contextMenu.item.fontWeight, ({
  theme
}) => theme.buttonGroup.contextMenu.item.lineHeight, ({
  theme
}) => theme.buttonGroup.contextMenu.item.letterSpacing, props => props.theme.colors.buttonGroup.contextMenu.textColor, ({
  theme
}) => theme.buttonGroup.contextMenu.item.textTransform, props => props.isDisabled ? 0.3 : 1);
const ContextMenu = exports.ContextMenu = _styledComponents.default.div.withConfig({
  displayName: "contextMenu__ContextMenu",
  componentId: "sc-5y83bd-3"
})(["width:", ";cursor:pointer;position:relative;margin:", ";border-width:", ";border-style:", ";border-color:", ";background-color:", ";height:100%;display:flex;align-items:center;justify-content:center;&::before{content:'';visibility:", ";opacity:", ";display:", ";width:12px;height:12px;border:1px solid #fff;position:absolute;top:-6px;transform:translateX(-50%) rotate(45deg);border-width:0 1px 1px 0;border-style:solid;border-color:", ";background-color:", ";z-index:100;left:50%;}&:hover{background-color:", ";}"], ({
  theme
}) => theme.buttonGroup.contextMenu.trigger.width, ({
  theme
}) => theme.buttonGroup.contextMenu.trigger.margin, ({
  theme
}) => theme.buttonGroup.contextMenu.trigger.borderWidth, ({
  theme
}) => theme.buttonGroup.contextMenu.trigger.borderStyle, ({
  theme
}) => theme.colors.buttonGroup.contextMenu.trigger.borderColor, ({
  active,
  theme
}) => active ? theme.colors.buttonGroup.contextMenu.trigger.hoverBg : theme.colors.buttonGroup.contextMenu.trigger.bg, ({
  active
}) => active ? 'visible' : 'hidden', ({
  active
}) => active ? '1' : '0', ({
  theme
}) => theme.name === 'prizm' || theme.name === 'prizm-next' ? 'block' : 'none', ({
  theme
}) => theme.colors.buttonGroup.contextMenu.item.border, ({
  lastItemHovered,
  theme
}) => lastItemHovered ? theme.colors.buttonGroup.contextMenu.trigger.hoverBg : theme.colors.buttonGroup.contextMenu.trigger.bg, ({
  theme
}) => theme.colors.buttonGroup.contextMenu.trigger.hoverBg);
const ContextMenuList = exports.ContextMenuList = _styledComponents.default.div.withConfig({
  displayName: "contextMenu__ContextMenuList",
  componentId: "sc-5y83bd-4"
})(["padding:", ";background-color:", ";box-shadow:", ";max-height:350px;overflow:auto;bottom:100%;right:0;text-align:left;position:absolute;visibility:", ";opacity:", ";transform:translateY(0);z-index:10;"], ({
  theme
}) => theme.buttonGroup.contextMenu.popup.padding, ({
  theme
}) => theme.colors.buttonGroup.contextMenu.item.bg, ({
  theme
}) => theme.colors.buttonGroup.contextMenu.shadow, props => props.isContextMenuListOpen ? 'visible' : 'hidden', props => props.isContextMenuListOpen ? 1 : 0);